import { render, staticRenderFns } from "./TranslationsGroupCardPage.vue?vue&type=template&id=542ea4fb"
import script from "./TranslationsGroupCardPage.vue?vue&type=script&lang=js"
export * from "./TranslationsGroupCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports